// import { formatRole } from '@/helpers/permission'
import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loadingAddBonus: false,
  loadingAvailableBonus: false,
  availableBonus: null,
  loadingBetLimit: false,
  loadingBonusDeduct: false,
});

export default {
  namespaced: true,

  state: initState(),

  mutations: {
    ADD_BONUS_USER: (s, data) => (s.loadingAddBonus = data),
    GET_BONUS_AVAILABLE: (s, data) => (s.loadingAvailableBonus = data),
    SET_AVAILABLE_BONUS: (s, data) => (s.availableBonus = data),
    SET_BET_LIMIT: (s, data) => (s.loadingBetLimit = data),
    LOAD_BONUS_DEDUCT: (s, data) => (s.loadingBonusDeduct = data),
  },

  actions: {
    async addBonusForUser({ commit }, params) {
      commit("ADD_BONUS_USER", true);
      try {
        const res = await this.$api.post("/v1/portal/bonuses/users", params);
        const data = res.data;
        return data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("ADD_BONUS_USER", false);
      }
    },
    async getAvailableBonus({ commit }, userId) {
      commit("GET_BONUS_AVAILABLE", true);
      try {
        const res = await this.$api.get(
          `/v1/portal/bonuses/users/${userId}?shouldOnlySum=true`
        );
        if (typeof res.data.data === "number") {
          commit("SET_AVAILABLE_BONUS", res.data.data);
        } else {
          commit("SET_AVAILABLE_BONUS", 0);
        }
        const data = res.data;
        return data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("GET_BONUS_AVAILABLE", false);
      }
    },
    async getListAvailableBonus({ commit }, userId) {
      commit("GET_BONUS_AVAILABLE", true);
      try {
        const res = await this.$api.get(`/v1/portal/bonuses/users/${userId}`);
        return res.data.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("GET_BONUS_AVAILABLE", false);
      }
    },
    async setBetLimit({ commit }, params) {
      commit("SET_BET_LIMIT", true);
      try {
        const res = await this.$api.post("/v1/portal/bet-limit", params);
        const data = res.data;
        return data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("SET_BET_LIMIT", false);
      }
    },
    async updateBonus({ commit }, params) {
      commit("LOAD_BONUS_DEDUCT", true);
      try {
        const { bonusOfferId, ...rest } = params;
        const res = await this.$api.put(
          `/v1/portal/bonuses/${bonusOfferId}/user`,
          rest
        );
        return res.data.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_BONUS_DEDUCT", false);
      }
    },
  },
};
